module.exports = __webpack_public_path__ + "img/stone-ore.e1416496.png";